/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useAnalytics } from '../../utils/analytics-provider/analytics-provider';
import { isClient } from '../../utils/is-client';

export const SendInViewEvent = ({
  isLoading,
  component_name,
  data,
  triggerOnce = false,
  trackVisibility = false,
  delay = 100
}) => {
  if (!isClient()) return [];

  const { trackEvent } = useAnalytics();
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce,
    trackVisibility,
    delay
  });

  if (!isLoading && inView) trackEvent('component_in_view', { component_name, data });

  return [ref, inView];
};

export const OnSiteUnload = ({ trackEvent }) => {
  if (!isClient()) return;

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      trackEvent('leave_support_center');

      if (event.defaultPrevented) event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
};
